import Glide from '@glidejs/glide';

let glideInstance = null;

function updateMetaFromSlide(index) {
  // Use only real slides (exclude Glide's clones) to avoid index mismatch
  const slides = Array.from(document.querySelectorAll('#gallery-glide .glide__slides > .glide__slide:not(.glide__slide--clone)'));
  const slide = slides[index];
  if (!slide) {
    return;
  }
  const heading = slide.getAttribute('data-heading') || '';
  const desc = slide.getAttribute('data-text') || '';
  const titleEl = document.querySelector('.gallery-modal__title');
  const descEl = document.querySelector('.gallery-modal__desc');
  if (titleEl) {
    titleEl.textContent = heading;
  }
  if (descEl) {
    descEl.textContent = desc;
  }
}

function openModal(startIndex) {
  const modal = document.getElementById('gallery-modal');
  if (!modal) {
    return;
  }
  document.body.classList.add('modal-open');
  modal.setAttribute('aria-hidden', 'false');

  // If an instance already exists (re-opening), destroy first
  if (glideInstance) {
    try { glideInstance.destroy(); } catch (e) {}
    glideInstance = null;
  }

  glideInstance = new Glide('#gallery-glide', {
    type: 'carousel',
    startAt: Number(startIndex) || 0,
    animationDuration: 400,
    perView: 1,
    keyboard: true,
    gap: 0,
  });

  // Update meta on mount and after slide changes
  glideInstance.on(['mount.after', 'run.after'], () => {
    updateMetaFromSlide(glideInstance.index);
  });

  glideInstance.mount();
}

function closeModal() {
  const modal = document.getElementById('gallery-modal');
  if (!modal) {
    return;
  }
  if (glideInstance) {
    try { glideInstance.destroy(); } catch (e) {}
    glideInstance = null;
  }
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
}

function bindEvents() {
  const modal = document.getElementById('gallery-modal');
  if (!modal) {
    return;
  }

  // Open from grid item
  const cards = Array.from(document.querySelectorAll('.gallery .gallery-card'));
  cards.forEach((card) => {
    card.addEventListener('click', (e) => {
      e.preventDefault();
      const index = card.getAttribute('data-index') || 0;
      openModal(index);
    });
  });

  // Close controls
  const overlay = modal.querySelector('.gallery-modal__overlay');
  const closeBtn = modal.querySelector('.gallery-modal__close');
  if (overlay) {
    overlay.addEventListener('click', () => closeModal());
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeModal());
  }

  // Keyboard handlers
  document.addEventListener('keydown', (e) => {
    const isHidden = modal.getAttribute('aria-hidden') !== 'false';
    if (isHidden) {
      return;
    }
    if (e.key === 'Escape') {
      closeModal();
    } else if (e.key === 'ArrowLeft' && glideInstance) {
      glideInstance.go('<');
    } else if (e.key === 'ArrowRight' && glideInstance) {
      glideInstance.go('>');
    }
  });
}

export default function() {
  // Only initialise on pages that have a gallery
  const grid = document.querySelector('.gallery');
  if (!grid) {
    return;
  }
  bindEvents();
}


